import { logger } from '@/features/print/logger'
import type { Printer } from '@/features/print/types'
import { PrintersThunkApi } from '@/redux/reducers/printers/types'
import type { RootState } from '@/redux/store'
import storageService from '@/services/storage'

export async function updatePersistentPrinters(
    transform: (printers: Printer[]) => Printer[],
    thunkApi: PrintersThunkApi,
    errorMsg: string
): Promise<Printer[]> {
    const state = thunkApi.getState() as RootState
    const currentPrinters = state.printers.printers

    if (!currentPrinters) {
        return thunkApi.rejectWithValue('Printers not loaded yet.')
    }

    const updatedPrinters = transform(currentPrinters)

    try {
        await storageService.setPrinters(updatedPrinters)

        return updatedPrinters
    } catch (e) {
        logger.errorOnly(e)

        return thunkApi.rejectWithValue(errorMsg)
    }
}
